/* eslint-disable */


import React, { useState } from "react";
import { NavLink, useHistory } from "react-router-dom";

// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/fobosMobile.png";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";


//Abel
import { useValidPassword, useValidEmail } from "hooks/useAuthHooks";
import { signInUser } from "libs/firebase/firebase";

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = "fobos.red"

  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);


  //Abel
  const { email, setEmail, emailIsValid } = useValidEmail('')
  const { password, setPassword, passwordIsValid } = useValidPassword('')
  const [error, setError] = useState('')
  const history = useHistory();


  //@ts-ignore
  const processSetEmail = (even: any) => { setEmail(event.target.value); }
  //@ts-ignore
  const processSetPassword = (even: any) => { setPassword(event.target.value); }

  const isValid = !emailIsValid || email.length === 0 || !passwordIsValid || password.length === 0

  //alert("Las votaciones aún no están abiertas, por favor espera a que se abran para poder votar. Aunque veas la opción de 'Acceder', no podrás hacerlo hasta que se abran las votaciones. Gracias por tu paciencia.");

  const signInClicked = async () => {

    try {
      const userCredential = await signInUser(email, password)
      if (userCredential) {
        history.push('/awards')
      }
    } catch (err: any) {
      console.log("Somthing happen during login");
      if (err.code === 'UserNotConfirmedException') {
        console.log(err);
      } else if (err.code === "auth/wrong-password"){
        //@ts-ignore
        setError("Contraseña incorrecta, si no recuerdas la contraseña puedes reestablecerla desde la app de Fobos.");
      } else {
        setError('Algo salió mal, por favor intenta de nuevo.')
      }
    }
  }

  

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex maxW={{ base: "100%", md: "max-content" }} w='100%' mx={{ base: "auto", lg: "0px" }} me='auto' h='100%'
        alignItems='start'
        justifyContent='center'
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection='column'>
        <Box me='auto'>
          <Heading color={textColor} fontSize='36px' mb='10px'>
            Acceder
          </Heading>
          <Text mb='36px' ms='4px' color={textColor} fontWeight='400' fontSize='md'>
            Usa tus credenciales de la app de Fobos para entrar
          </Text>
        </Box>
        <Flex
          zIndex='2'
          direction='column'
          w={{ base: "100%", md: "420px" }}
          maxW='100%'
          background='transparent'
          borderRadius='15px'
          mx={{ base: "auto", lg: "unset" }}
          me='auto'
          mb={{ base: "20px", md: "auto" }}>

          <FormControl>
            <FormLabel display='flex' ms='4px' fontSize='sm' fontWeight='500' color={textColor} mb='8px'>
              Email<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              variant='auth'
              fontSize='sm'
              ms={{ base: "0px", md: "0px" }}
              id="email"
              type='email'
              placeholder='ejemplo@fobosescape.com'
              mb='24px'
              fontWeight='500'
              size='lg'
              //emailIsValid={emailIsValid} 
              onChange={processSetEmail}

            />
            <FormLabel
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              display='flex'>
              Contraseña<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size='md'>
              <Input
                isRequired={true}
                id="password"
                fontSize='sm'
                placeholder='Min. 8 caracteres'
                mb='24px'
                size='lg'
                type={show ? "text" : "password"}
                variant='auth'
                onChange={processSetPassword}
              />
              <InputRightElement display='flex' alignItems='center' mt='4px'>
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: "pointer" }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Text color="red">
              {error + "\r\n"}
            </Text>
            
            <Button
              fontSize='sm'
              variant='darkBrand'
              fontWeight='500'
              w='100%'
              h='50'
              mb='24px'
              //disabled={true}
              onClick={signInClicked}
            >
              Acceder
            </Button>
            <Box me='auto'>
              <Heading color={textColor} fontSize='24px' mb='10px'>
                ¿No tienes cuenta?
              </Heading>
              <Text mb='36px' ms='4px' color={textColor} fontWeight='400' fontSize='md'>
                ¡Descarga ya la App de Fobos y crea tu cuenta! <Link href="https://fobosescape.com/el-siguiente-nivel/" isExternal variant='fobos'>Pincha aquí</Link>
              </Text>
        </Box>
          </FormControl>
        </Flex>
        
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
